<template>
  <div class="individual_i">
    <PageContent>
      <StepsV2 :step="3" />
      <PanelV2
        type="w6"
        title="What's your BDO Settlement Account?"
        @nextClick="commitData()"
      >
        <template v-slot:title-solt> </template>
        <template v-slot:content-solt>
          <AppForm
            ref="appForm"
            v-model="formData"
            :toggleContact="showAccount"
          />
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
import AppForm from "../forms/SolePropI.val";
import API from "@/api";

export default {
  name: "IndividualI",
  pRouter: "IndividualH",
  components: {
    AppForm,
  },
  data() {
    return {
      formData: {
        accountName: "",
        accountNumber: "",
        bankType: "",
      },
      showAccount: false,
    };
  },
  watch: {
    "formData.bankType": {
      handler(val) {
        this.showAccount = val !== "3" && val != '';
        if (val == '3') {
          this.formData.accountName = ''
          this.formData.accountNumber = ''
        } else {
          this.$nextTick(() => {
            this.$refs.appForm.$refs.appForm.clearValidate()
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    commitData() {
      if(this.formData.bankType == '') {
        this.showMessageTip('Bank is error')
        return
      }
      if (this.formData.bankType == 3) {
        this.$refs.appForm.updateDataForm({
          bankType: "3",
          accountName: "",
          accountNumber: "",
        });
        this.doCommit();
        this.$router.push({ path: "/individual-m" });
      } else {
        this.$refs.appForm.$refs.appForm.validate((valid) => {
          if (valid) {
            this.doCommit();
          }
        });
      }
    },
    doCommit() {
      const data = this.formatCommitData({ ...this.formData });
      API.addBdoProcess({
        ...data,
      }).then((res) => {
        if (res.success) {
          this.toNext();
        }
      });
    },
  },
};
</script>


<style lang="scss">
.individual_i {
  .content {
    & > div {
      min-height: 292px;
    }
  }
}
.el-form.SolePropI {
  margin-bottom: 54px !important;
  .el-form-item:nth-child(4) {
    margin-top: -120px;
  }
}
</style>
